export default __webpack_public_path__ + "static/connect-9ede873ad0c7d08d2de177d8adf96e93.webp";